'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bearer = exports.query = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Imports
                                                                                                                                                                                                                                                                   */

var _reduxEffectsFetch = require('redux-effects-fetch');

/**
 * Credential middleware
 */

function query(pattern, name, getToken) {
  return abstractMw(pattern, getToken, function (payload, token) {
    return _extends({}, payload, {
      url: decorate(payload.url, token)
    });
  });

  function decorate(url, token) {
    if (!token) return url;

    var _url$split = url.split('?'),
        _url$split2 = _slicedToArray(_url$split, 2),
        base = _url$split2[0],
        _url$split2$ = _url$split2[1],
        qs = _url$split2$ === undefined ? '' : _url$split2$;

    var param = [name, token].map(encodeURIComponent).join('=');

    return [base, qs.split('&').concat(param).filter(Boolean).join('&')].join('?');
  }
}

function bearer(pattern, getToken) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Bearer';

  return abstractMw(pattern, getToken, function (payload, token) {
    return !token ? payload : _extends({}, payload, {
      params: _extends({}, payload.params || {}, {
        headers: _extends({}, (payload.params || {}).headers || {}, {
          Authorization: prefix + ' ' + token
        })
      })
    });
  });
}

function abstractMw(pattern, getToken, xf) {
  var isMatch = matcher(pattern);
  return function (ctx) {
    return function (next) {
      return function (action) {
        return action.type === _reduxEffectsFetch.FETCH && isMatch(action.payload.url) ? next(_extends({}, action, { payload: xf(action.payload, getToken(ctx)) })) : next(action);
      };
    };
  };
}

function matcher(pattern) {
  return typeof pattern === 'function' ? pattern : function (url) {
    return pattern.test(url);
  };
}

/**
 * Exports
 */

exports.query = query;
exports.bearer = bearer;